// Router `state` the paywall attaches to its Terms/Privacy links, so those pages know to
// offer a way back into the purchase flow (see components/PaywallReturnLink.js).
//
// Its own module rather than exported from PaywallReturnLink: that component imports
// PaywallContext, which imports Paywall, so Paywall importing it back would be a cycle.
export const FROM_PAYWALL_STATE = Object.freeze({ fromPaywall: true });
